import { camelCase } from 'voca';
import { DashboardType } from './analytics.types';
import { PageIdentifier, Routing } from '@/constants';
import { useIsLoadingAnalyticsDashboards } from './analytics.context';
import { PIPELINE_HEALTH_TITLE_GOOGLE, PIPELINE_HEALTH_TITLE_WEBSITE } from '../pipeline-health/pipeline-health.constants';
export const excludedDashboardsFromRoute = [PIPELINE_HEALTH_TITLE_WEBSITE, PIPELINE_HEALTH_TITLE_GOOGLE];
export const normalizeDashboardTitle = (title) => camelCase(title);
const isDashboardType = (value) => Object.values(DashboardType).includes(value);
export const isBeaconDashboardVisible = (title, isBeaconValidationEnabled) => {
    const normalized = normalizeDashboardTitle(title);
    if (!isDashboardType(normalized))
        return true;
    if (normalized === DashboardType.BEACON_EVENT_VALIDATION)
        return isBeaconValidationEnabled;
    return true;
};
export const dashboardTitleToLocalizedMessageKey = (title) => {
    const normalizedDashboardTitle = normalizeDashboardTitle(title);
    if (isDashboardType(normalizedDashboardTitle)) {
        switch (normalizedDashboardTitle) {
            case DashboardType.SEARCH_PERFORMANCE:
                return 'SEARCH_PERFORMANCE';
            case DashboardType.SEARCH_TERM_ANALYSIS:
                return 'SEARCH_TERM_ANALYSIS';
            case DashboardType.FACET_ENGAGEMENTS:
                return 'FACET_ENGAGEMENTS';
            case DashboardType.NULL_SEARCH_ANALYTICS:
                return 'NULL_SEARCH_ANALYTICS';
            case DashboardType.RULE_ANALYTICS:
                return 'RULE_ANALYTICS';
            case DashboardType.BIASING_PROFILE:
                return 'BIASING_PROFILE';
            case DashboardType.BEACON_EVENT_VALIDATION:
                return 'BEACON_EVENT_VALIDATION';
        }
    }
    return title; // unlocalized
};
export const useGetAnalyticsDashboardType = (modelPath, paths) => {
    const isLoadingAnalytics = useIsLoadingAnalyticsDashboards();
    if (!modelPath || !isAnalyticsChartPage(modelPath) || isLoadingAnalytics) {
        return undefined;
    }
    const pathDepthIsSectionPage = paths.length < 5;
    // show default dashboard if on homepage or on analytics route with no dashboard type path
    if (modelPath === PageIdentifier.HOME_DASHBOARDS || pathDepthIsSectionPage)
        return DEFAULT_DASHBOARD_TYPE;
    return paths.pop();
};
export const isAnalyticsChartPage = (modelPath) => {
    if (!modelPath)
        return false;
    return modelPath === Routing.ROUTE_PATHS[PageIdentifier.ANALYTICS];
};
export const DEFAULT_DASHBOARD_TYPE = DashboardType.SEARCH_PERFORMANCE;
